import { render, staticRenderFns } from "./txt.vue?vue&type=template&id=5b47f6d1&scoped=true&"
import script from "./txt.vue?vue&type=script&lang=js&"
export * from "./txt.vue?vue&type=script&lang=js&"
import style0 from "./txt.vue?vue&type=style&index=0&id=5b47f6d1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b47f6d1",
  null
  
)

export default component.exports